export default "__VITE_ASSET__Cc9ssi8r__"